import { Shuffle } from '@mui/icons-material';
import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography
} from '@mui/material';
import { iconDelete, iconEdit } from 'Assets/index';

const DropdownItemList = ({
  items,
  selectedItem,
  selectedParent,
  isEditable,
  onSelect,
  onEdit,
  onDelete,
  onShuffle
}) => (
  <Box mt={2} mb={1}>
    {selectedParent && (
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle2" fontWeight="bold">
          {selectedParent?.value}
        </Typography>

        <IconButton onClick={() => onShuffle(selectedParent?.id)} size="small">
          <Shuffle fontSize="small" />
        </IconButton>
      </Box>
    )}

    <List dense>
      {items.map((item, idx) => {
        return (
          <ListItem
            key={item.id || item.key || idx}
            component="li"
            onClick={() => onSelect(item)}
            className={`categorized-list-item${item.key === selectedItem?.key ? ' selected' : ''}`}>
            <ListItemText
              primary={item.value}
              primaryTypographyProps={{ className: 'list-item-text' }}
            />
            <ListItemSecondaryAction sx={{ right: 0 }}>
              <Box className="item-actions">
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(item);
                  }}
                  size="small">
                  <img src={iconDelete} alt="Delete" />
                </IconButton>
                {isEditable && (
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      onEdit(item, idx);
                    }}
                    size="small">
                    <img src={iconEdit} alt="Edit" />
                  </IconButton>
                )}
              </Box>
            </ListItemSecondaryAction>
          </ListItem>
        );
      })}
    </List>
  </Box>
);

export default DropdownItemList;
